export const SMART_COOLER_TEST_IDS = {
  PAGE: 'smart-cooler-page',
  FILTER_DROPDOWN: 'smart-cooler-filter-dropdown',
  STATUS_FILTER: 'smart-cooler-status-filter',
  TABLE: 'smart-cooler-table',
  TABLE_ROW: (id: string) => `smart-cooler-table-row-${id}`,
  COL_COOLER_ID: (id: string) => `smart-cooler-col-cooler-id-${id}`,
  COL_NATIVE_ID: (id: string) => `smart-cooler-col-native-id-${id}`,
  COL_DEVICE_ID: (id: string) => `smart-cooler-col-device-id-${id}`,
  COL_OPERATOR_INFO: (id: string) => `smart-cooler-col-operator-info-${id}`,
  COL_MARKET_ID: (id: string) => `smart-cooler-col-market-id-${id}`,
  COL_DEVICE_TYPE: (id: string) => `smart-cooler-col-device-type-${id}`,
  COL_STATUS: (id: string) => `smart-cooler-col-status-${id}`,
  COL_SYSTEM_STATE: (id: string) => `smart-cooler-col-system-state-${id}`,
  COL_CREATED_ON: (id: string) => `smart-cooler-col-created-on-${id}`,
  COL_LASTHEARTBEAT_DTM: (id: string) => `smart-cooler-col-lastheartbeat-dtm-${id}`,

  // ── ViewSmartCooler page ────────────────────────────────────────────
  VIEW_PAGE: 'smart-cooler-view-page',
  VIEW_BACK_BTN: 'smart-cooler-view-back-btn',
  VIEW_FETCH_LOGS_BTN: 'smart-cooler-view-fetch-logs-btn',

  // ── FetchLogModal ───────────────────────────────────────────────────
  FETCH_LOG_RANGE_TODAY: 'smart-cooler-fetch-log-range-today',
  FETCH_LOG_RANGE_2_DAYS: 'smart-cooler-fetch-log-range-2-days',
  FETCH_LOG_RANGE_3_DAYS: 'smart-cooler-fetch-log-range-3-days',
  FETCH_LOG_CANCEL_BTN: 'smart-cooler-fetch-log-cancel-btn',
  FETCH_LOG_SUBMIT_BTN: 'smart-cooler-fetch-log-submit-btn',
  FETCH_LOG_DONE_BTN: 'smart-cooler-fetch-log-done-btn',

  // ── ViewSCConnectionTab ─────────────────────────────────────────────────
  CONN_FETCH_BTN: 'smart-cooler-conn-fetch-btn',
  CONN_VIEW_LOGS_BTN: 'smart-cooler-conn-view-logs-btn',

  // ── ViewSCDeviceLogsTab ─────────────────────────────────────────────────
  LOGS_REFRESH_BTN: 'smart-cooler-logs-refresh-btn',
  LOGS_FETCH_BTN: 'smart-cooler-logs-fetch-btn',
  LOGS_PREV_BTN: 'smart-cooler-logs-prev-btn',
  LOGS_NEXT_BTN: 'smart-cooler-logs-next-btn',
  LOGS_EMPTY_FETCH_BTN: 'smart-cooler-logs-empty-fetch-btn',
  LOGS_EXPAND_ROW: (id: string) => `smart-cooler-logs-expand-row-${id}`,
  LOGS_DOWNLOAD_BTN: (id: string) => `smart-cooler-logs-download-btn-${id}`,

  // ── ViewSCActionLogsTab ─────────────────────────────────────────────────
  ACTION_LOGS_REFRESH_BTN: 'smart-cooler-action-logs-refresh-btn',
  ACTION_LOGS_RETRY_BTN: 'smart-cooler-action-logs-retry-btn',
  ACTION_LOGS_LOAD_MORE_BTN: 'smart-cooler-action-logs-load-more-btn',
  ACTION_LOGS_EXPAND_ROW: (id: string) =>
    `smart-cooler-action-logs-expand-row-${id}`,

  // ── ViewSCConnectionLogsTab ──────────────────────────────────────────────
  CONN_LOGS_REFRESH_BTN: 'smart-cooler-conn-logs-refresh-btn',
  CONN_LOGS_RETRY_BTN: 'smart-cooler-conn-logs-retry-btn',
  CONN_LOGS_LOAD_MORE_BTN: 'smart-cooler-conn-logs-load-more-btn',
  CONN_LOGS_EXPAND_ROW: (id: string) =>
    `smart-cooler-conn-logs-expand-row-${id}`,

  // ── AppLogExpandedPanel (DeviceLogs / ActionLogs / ConnectionLogs rows) ──
  APP_LOG_EXPANDED_PANEL: 'smart-cooler-app-log-expanded-panel',
  APP_LOG_EXPANDED_TAB_CONTROL: 'smart-cooler-app-log-expanded-tab-control',
  APP_LOG_EXPANDED_SECTION: (key: string) =>
    `smart-cooler-app-log-expanded-section-${key.toLowerCase()}`,
} as const;
